import {
	Assignment, DangerousGoodsModel,
} from 'models';
import {
	useEffect, useState,
} from 'react';
import {
	DangerousGoodsIcon,
} from './DangerousGoodsIcon';


import {
	FieldWithIcon,
} from '../fieldWithIcon/FieldWithIcon';
import {
	DangerousGoodsList,
} from '../modals/deviations/list/DangerousGoodsList';
import './dangerousGoodsField.scss';
import {
	isDone,
} from '../../../../../utils/transport';

interface Props {
	assignment: Assignment,
}

export const DangerousGoodsField = ({
	assignment,
}: Props) => {
	/**
	 * Only goods items with dangerous goods
	 */
	const [goodsItems, setGoodsItems] = useState<DangerousGoodsModel[]>();
	const [show, setShow] = useState<boolean>(false);
	const isAssignmentDone = isDone(assignment);

	const onClick = () => setShow(true);

	useEffect(() => {
		if (assignment?.goods?.dangerousGoods && Object.keys(assignment.goods.dangerousGoods).length > 0) {
			const list: DangerousGoodsModel[] = [assignment.goods.dangerousGoods]
			// TODO: If we implement support for multiple: .filter(item => item.dangerousGoods !== undefined);
			setGoodsItems(list);
		}
	}, [assignment?.goods?.dangerousGoods]);

	if (goodsItems) {
		return (
			<>
				{goodsItems.filter(goods => goods.unno)
					.map((goods, index) => (
						<FieldWithIcon
							key={`${goods.unno}_${goods.hazardIdentificationNumber}_${goods.name}`}
							header="Farlig gods"
							// @ts-ignore - We have already filtered the ones without away...
							icon={<div className="dangerous-goods-field-main-icon">
								<DangerousGoodsIcon
									dangerousGoods={goods}
									done={isAssignmentDone}
								/>
							</div>}
							// @ts-ignore - We have already filtered the ones without away...
							description={goods?.name || 'Navn mangler'}
							onClick={index === 0 ? onClick : undefined}
						/>
					))}
				{goodsItems && show && (
					<DangerousGoodsList
						goods={goodsItems}
						onClose={() => {
							setShow(false);
						}}
					/>
				)}
			</>
		);
	}
	return null;
};